import {
  ActionReducerMapBuilder,
  PayloadAction,
  createReducer,
} from "@reduxjs/toolkit";
import { storeAPIError } from "../actions";
import { DefaultGlobalState, GlobalState } from "../state/stateItems/global";

const handleStoreAPIError = (
  state: GlobalState,
  action: PayloadAction<string | null>
) => {
  console.log(action.payload);
  state.APIErrors = action.payload;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<GlobalState>) => {
  builder.addCase(storeAPIError.type, handleStoreAPIError);
};

export default createReducer(DefaultGlobalState, reducerBuilder);
